import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import { ReactNode } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
const reCaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_KEY

type AppLayoutProps = {
  variant?: 'primary' | 'secondary'
  children: ReactNode
}

const paypalClientId = process.env.NEXT_PUBLIC_PAYPAL_CLIENT_ID as string

const AppLayout = ({ children }: AppLayoutProps) => {

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={reCaptchaKey}
      useEnterprise={true}
      scriptProps={{
        async: true,
        defer: false,
        appendTo: 'body',
      }}
    >
      <PayPalScriptProvider
        options={{
          clientId: paypalClientId,
          components: "buttons",
          currency: "EUR",
          disableFunding: "card"
        }}
      >
        {children}
      </PayPalScriptProvider>
    </GoogleReCaptchaProvider>
  )
}

export default AppLayout
